<div class="delete-role-dialog">
  <h2 class="headline">
    {{
      "VIRTUAL_POS_PAGE.MODAL_BLOCK." +
        (this.groupStatus === "blocked"
          ? "GROUP_UNLOCK_TITLE"
          : "GROUP_BLOCK_TITLE") | translate
    }}
  </h2>
  <p class="description">
    {{
      "VIRTUAL_POS_PAGE.MODAL_BLOCK." +
        (this.groupStatus === "blocked"
          ? "GROUP_UNLOCK_DESCRIPTION"
          : "GROUP_BLOCK_DESCRIPTION") | translate
    }}
  </p>
  <h3 class="subtitle"></h3>
  <div class="btn-block">
    <button (click)="toggleBlock()" class="btn btn-accent">
      {{
        "VIRTUAL_POS_PAGE.MODAL_BLOCK." +
          (this.groupStatus === "blocked" ? "UNLOCK" : "BLOCK") | translate
      }}
    </button>
    <button (click)="closeModal()" class="btn btn-light">
      {{ "VIRTUAL_POS_PAGE.MODAL_BLOCK.CANCEL" | translate }}
    </button>
  </div>
</div>
